import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DbActivityLog } from 'fakturnia-shared';

@Component({
  standalone: true,
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  selector: 'activity-logs',
  templateUrl: './activity-logs.component.html',
  styleUrls: ['./activity-logs.component.scss']
})
export class ActivityLogsComponent {

  @Input() activityLogs: DbActivityLog[] = []
  
  // Track which logs have expanded details
  expandedDetails = new Set<string>();

  toggleDetails(logId: string): void {
    if (this.expandedDetails.has(logId)) {
      this.expandedDetails.delete(logId);
    } else {
      this.expandedDetails.add(logId);
    }
  }

  isExpanded(logId: string): boolean {
    return this.expandedDetails.has(logId);
  }
}
